/* @flow */

import React, { PureComponent } from "react";
import { View, Text, Image, Pressable, Linking } from "react-native";

//Modules

// import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';

//Components
import Tabs from "../components/general/tabs.js";
import Background from "../components/general/background.js";
import Loading from "../components/general/loading.js";
import Match from "../components/matches/match.js";
import BottomNavbar from "../components/navigation/bottomnavbar.js";

import H2H from "./match/h2hbios.js";
import Preview from "./match/preview.js";
import Recap from "./match/recap.js";
import Stats from "./match/stats.js";
// import Watch from "./match/watch.js";
import Odds from "./match/odds.js";
import Form from "./player/form.js";
import * as BlazeSDK from "@wscsports/blaze-web-sdk";
import Player from "../components/general/player.js";

import { getApp } from "firebase/app";
import { getFirestore, doc, onSnapshot } from "firebase/firestore";

// import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

//Helpers
import MainStyles from "../helpers/mainstyles.js";
import GLOBAL from "../helpers/global.js";
import Functions from "../helpers/functions.js";
import useList from "../helpers/useList.js";
import getDomain from "../helpers/getDomain.js";
import { Hoverable } from "react-native-web-hover";
// import Pressable from 'react-native/Libraries/Components/Pressable/Pressable.js';

// const H2H = React.lazy(() => import("./match/h2hbios.js"));
// const Preview = React.lazy(() => import("./match/preview.js"));
// const Recap = React.lazy(() => import("./match/recap.js"));
// const Stats = React.lazy(() => import("./match/stats.js"));
const Watch = React.lazy(() => import("./match/watch.js"));
// const Odds = React.lazy(() => import("./match/odds.js"));
// const Form = React.lazy(() => import("./player/form.js"));

// // Initialize Firebase
const app = getApp();
const db = getFirestore(app);

export default class MyComponent extends PureComponent {
  //Setup
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      activeView: "Live",
      id: this.props?.id || this.props?.route?.params?.id,
      hideNav: this.props?.route?.params?.hideNav,
      watch: this.props.route?.params?.watch,
      autoplay: !!this.props.route?.params?.autoplay,
      mounted: true,
      description:
        "Live scores, stats, point by point recaps, commentary, streams and bios.",
      lastUpdate: 0,
    };
    this.unsubscribeFirestore = null;
  }

  componentDidMount = async () => {
    // const domain = getDomain()

    // //Shared WSC link
    // try {
    //   if(!this.state.has_set_wsc){
    //     if (
    //       window?.location?.hash &&
    //       window.location.hash.includes("blaze/story/")
    //     ) {
    //       const wsc_hash = window.location.hash.split("/story/")[1];
    //       await this.setState({ wsc_hash, autoplay: true, has_set_wsc:true });
    //     }else{
    //       await this.setState({ has_set_wsc:true });
    //     }
    //   }
    // } catch (e) {
    //   console.error(e);
    // }

    const displayList = useList();
    this.setState({ displayList });
    setTimeout(() => {
      if (this.state.hideNav && GLOBAL.hideNav) {
        GLOBAL.hideNav();
      }
      this.setup();

      window.addEventListener("focus", this.handleFocus);
      window.addEventListener("blur", this.handleBlur);
      document.addEventListener(
        "visibilitychange",
        this.handleVisibilityChange
      );
    }, 350);
  };

  componentWillUnmount = async () => {
    this.unmountScreen();
  };

  componentDidUpdate = (prevProps) => {
    if (
      prevProps.route?.params?.content !== this.props.route?.params?.content
    ) {
      this.setState({ activeView: this.props.route?.params?.content });
    }
  };

  //
  handleFocus = () => {
    // console.log('match focus')
  };

  handleBlur = () => {
    // console.log('match blur')
    this.unmountScreen();
  };

  unmountScreen = () => {
    this.setState({ mounted: false });
    clearTimeout(this.refresh_data);
    this.refresh_data = null;
    window.removeEventListener("focus", this.handleFocus);
    window.removeEventListener("blur", this.handleBlur);
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    this.detachFirestore();
  };

  handleVisibilityChange = () => {
    const time_compare = this.state.refresh_time || 1 * 60 * 1000;

    // console.log('Visibility changed to: '+document.visibilityState, "Seconds to compare: "+time_compare/1000+" seconds")

    if (document.visibilityState === "visible") {
      //Trigger an update if the data was updated more than a minute ago
      if (Date.now() - this.state.lastUpdate > time_compare) {
        // console.log('Viewing page and data is stale, asking for refresh')
        this.setup();
      } else {
        // console.log('Viewing page but data is fresh, wait for next update')
      }
    }

    if (document.visibilityState === "visible") {
      this.setupFirestore();
    } else {
      this.detachFirestore();
    }
  };

  setup = async () => {
    clearTimeout(this.refresh_data);

    var id = this.props?.id || this.props?.route?.params?.id;

    var params = {
      id,
      mode: "match",
    };

    // if (GLOBAL.__DEV__)
    //   params.url = "https://gen2-web-api-testing-ysvbugl7mq-uc.a.run.app";

    var data_r = await Functions.tnnsAPI(params);
    var data = data_r?.data || {};

    var {
      tabs,
      tabs_sections,
      first_tab,
      match_card,
      match_card_daily,
      // related_links,
      header,
      abbreviations,
      players,
      notifications,
      favorite,
      isLive,
      refresh_time,
      stream_data,
      id,
      highlights,
      news,
      seo,
      wsc_story,
    } = data;

    // wsc_story = {
    //   thumbnail:{
    //     src:"https://graphicsfeprodeus2.prod-cdn.clipro.tv/dynamicassets/7f3f0a53-45ce-45a5-ae34-8c2b11ee8d66.jpg",
    //     aspectRatio:1,
    //   },
    //   sdkId:'68110e88cc6eef8262fd7a0b'
    // }

    this.refresh_time(refresh_time);

    //Section the related links by source
    let related_links;
    // try {
    //   if (data.related_links?.length) {
    //     let linksObj = {};
    //     data.related_links.forEach((link) => {
    //       if (!link.source) link.source = "Other";
    //       if (!linksObj[link.source])
    //         linksObj[link.source] = { title: link.source, data: [] };
    //       linksObj[link.source].data.push(link);
    //     });
    //     related_links = Object.values(linksObj).sort((a, b) =>
    //       a.title < b.title ? -1 : 1
    //     );
    //   }
    // } catch (e) {
    //   console.error(e);
    // }

    // delete tabs.tab_chat;
    // console.log(tabs)

    // if (GLOBAL.__DEV__) console.log(news);

    //Set the first tab
    if (this.props.route) {
      if (this.props.route?.params?.content)
        first_tab = this.props.route?.params?.content.toLowerCase();
    }
    if (this.props.navigation) {
      if (first_tab)
        this.props.navigation.setParams({ content: first_tab.toLowerCase() });
    }

    if (this.state.watch && first_tab) {
      first_tab = "watch";
    }

    tabs = Object.values(tabs || {});
    await tabs.sort((a, b) => (a.rank > b.rank ? 1 : -1));

    // tabs_sections = [{id:'chat', title:'Live Chat'}].concat(tabs_sections) //Demo

    //Setup the SEO title
    //Demo string - Live Scores & Updates Roger Federer vs Rafael Nadal - ATP Cup - Date - TNNS Live
    //LIVE UPDATES & STANDINGS Daniil Medvedev - Alex De Minaur - ATP Cup Singles - 4 January 2022 - Eurosport
    var title =
      "Live Scores & Updates " +
      seo.p1 +
      " vs " +
      seo.p2 +
      " - " +
      seo.tournament +
      " " +
      seo.format +
      " - " +
      seo.date +
      " - TNNS Live";
    var description =
      seo.p1 +
      " vs " +
      seo.p2 +
      " live score, streams, prediction, match preview, h2h record, stats on " +
      seo.date +
      " - " +
      seo.tournament;

    var seo_published_time = seo.published_time;
    var seo_modified_time = seo.modified_time;

    if (this.props.navigation) {
      if (this.props.navigation.setOptions) {
        this.props.navigation.setOptions({ title });
      }
    }
    this.setState({ title, description });

    if (!this.state.loading) {
      //Refreshing data
      await this.setState({
        seo_title: title,
        highlights,
        seo_published_time,
        seo_modified_time,
        tabs,
        tabs_sections,
        match_card,
        match_card_daily,
        header,
        id,
        abbreviations,
        players,
        stream_data,
        related_links,
        news,
        wsc_story,
        isLive,
        loading: false,
        lastUpdate: Date.now(),
      });
    } else {
      await this.setState({
        seo_title: title,
        highlights,
        seo_published_time,
        seo_modified_time,
        tabs,
        tabs_sections,
        first_tab,
        activeView: first_tab,
        match_card,
        match_card_daily,
        header,
        id,
        abbreviations,
        related_links,
        news,
        players,
        stream_data,
        wsc_story,
        notifications,
        favorite,
        isLive,
        loading: false,
        lastUpdate: Date.now(),
      });
    }

    if (!this.state.hasSetupFirestore) {
      await this.setState({ hasSetupFirestore: true });
      this.setupFirestore();
    }

    if (this.state.autoplay) {
      if (this.state.wsc_hash && GLOBAL.playWSCStory) {
        // const playerStyle = BlazeSDK.Theme("default").playerStyle;
        // BlazeSDK.playStory(this.state.wsc_hash, playerStyle);
        GLOBAL.playWSCStory(this.state.wsc_hash)
      } else if (highlights?.url) {
        this.openVideo()
      } else if (wsc_story) {
        this.playStory();
      }
    }
  };

  setupFirestore = () => {
    // console.log('Setup firestore')
    //Attach the listener
    this.unsubscribeFirestore = onSnapshot(
      doc(db, "matches_sr", this.state.id),
      (doc) => {
        this.updateFromFirestore(doc);
      }
    );
  };

  openVideo = () => {
    GLOBAL.showVideo(this.state.highlights.url, this.state.wsc_story?.sdkId);
  };

  playStory = () => {
    if (!this.state.wsc_story?.sdkId || !GLOBAL.playWSCStory) return;
    GLOBAL.playWSCStory(this.state.wsc_story?.sdkId)
  };

  updateFromFirestore = async (doc) => {
    // console.log('FS update received', Date.now(), document.visibilityState, `Mounted: ${this.state.mounted}`)
    if (this.state.match_card) {
      // let match_card = this.state.match_card;
      let match_card = { ...this.state.match_card };
      const sport_event_status = doc.data();

      if (sport_event_status.game_state && !sport_event_status.winner_id) {
        //Game Score
        if (sport_event_status.game_state) {
          match_card.game_score = [
            [
              {
                score: sport_event_status.game_state.home_score || "0",
                opacity: 1,
              },
              {
                score: sport_event_status.game_state.away_score || "0",
                opacity: 1,
              },
            ].map((obj) => {
              if (obj.score === 50) obj.score = "AD";
              return obj;
            }),
          ];

          // console.log(sport_event_status)

          //Point type
          match_card.strings.bottom_left =
            {
              match: "Match point",
              set: "Set point",
              break: "Break point",
            }[sport_event_status.game_state.point_type] || "Live";

          //Serving
          if (sport_event_status.game_state.serving === "home") {
            match_card.players[0].serving = true;
            match_card.players[1].serving = false;
          } else if (sport_event_status.game_state.serving === "away") {
            match_card.players[0].serving = false;
            match_card.players[1].serving = true;
          }
        } else {
          match_card.game_score = [];
          match_card.players[0].serving = false;
          match_card.players[1].serving = false;
        }

        //Period Score
        if (sport_event_status.period_scores?.length) {
          sport_event_status.period_scores.forEach((score, i) => {
            if (match_card.scores[i]) {
              match_card.scores[i][0].score = score.home_score;
              match_card.scores[i][1].score = score.away_score;
            }
          });
        }

        await this.setState({ match_card });
      }
    }

    // if(matches['sr:sport_event:58140567']){
    //   const match = matches['sr:sport_event:58140567']
    //   console.log(match.sport_event_status.game_state.home_score, match.sport_event_status.game_state.away_score)
    // }

    // await this.setState({ push: Object.assign(this.state.push, matches) });

    // //Update the list
    // this.filter_matches();
  };

  detachFirestore = () => {
    if (this.unsubscribeFirestore) {
      // console.log('Detaching FS')
      this.unsubscribeFirestore();
    }
  };

  changeTab = (tab) => {
    // console.log('tab', tab)
    // this.setState({ activeView: tab.id });
    if (this.props.navigation) {
      this.props.navigation.setParams({ content: tab.id });
    } else {
      // alert('ding')
      this.setState({ activeView: tab.id });
    }
  };

  //AppState & Reload Controls
  refresh_time = (refresh_time) => {
    this.setState({ refresh_time });
    // console.log('Will refresh in '+refresh_time/1000+' seconds')
    if (refresh_time) {
      this.refresh_data = setTimeout(() => {
        // console.log('Refresh 2')

        var update_data = true;

        if (document.visibilityState === "visible") {
          //Update, window is visible
          update_data = true;
        } else if (this.state.missedUpdates > (1000 * 5 * 60) / refresh_time) {
          //Data is 5 mins old, update
          // console.log('Missed enough updates, update the data')
          update_data = true;
        } else {
          //Window blurred, don't update
          update_data = false;
        }

        // console.log('Refresh requested', 'Visbility: '+document.visibilityState, 'Missed updates: '+this.state.missedUpdates, "Updating: "+update_data)

        if (update_data) {
          //Update
          this.setup();
          this.setState({ missedUpdates: 0 });
        } else {
          //Missed
          //Increase the missed update count and wait for another refresh
          this.setState({ missedUpdates: this.state.missedUpdates + 1 });
          this.refresh_time(refresh_time);
        }
      }, refresh_time);
    }
  };

  renderRightPanel = () => {
    const { highlights, related_links, news } = this.state;

    if (!highlights && !related_links?.length && !news) return null;

    return (
      <View style={{ width: "100%" }}>
        {this.renderHighlights()}
        {this.renderStory()}
        {this.renderPlayers()}
        {this.renderLinks()}
        {this.renderNews()}
      </View>
    );
  };

  renderContent = () => {
    var { overlay } = this.props;
    var { loading } = this.state;

    if (overlay) {
      return loading ? <Loading /> : this.renderMain();
    } else {
      return (
        <>
          <Background
            navigation={this.props.navigation}
            page={"Scores"}
            rightPanel={{
              render: this.renderRightPanel,
              // title: "Match highlights",
              // button: {
              //   cta: "Watch highlights",
              //   onPress: this.openVideo,
              // },
            }}
          >
            {loading ? <Loading /> : this.renderMain()}
          </Background>
          <BottomNavbar page="Scores" />
        </>
      );
    }
  };

  renderStream = () => {
    var { stream_data } = this.state;
    return (
      <>
        <Watch data={stream_data} player_only width={GLOBAL.column_width} />
      </>
    );
  };

  renderHeader = () => {
    var { header } = this.state;
    return (
      <View
        style={[
          {
            width: "100%",
            paddingVertical: GLOBAL.padding * 2,
            backgroundColor: GLOBAL.style.color,
          },
          MainStyles.flexCenter,
        ]}
      >
        <View
          style={[
            { width: "100%", maxWidth: GLOBAL.maxWidth },
            MainStyles.flexRow,
            MainStyles.flexStartCenter,
          ]}
        >
          <View
            style={[
              { flex: 1, paddingHorizontal: GLOBAL.padding },
              MainStyles.flexCenterStart,
            ]}
          >
            <Text
              style={{
                fontSize: 24,
                color: GLOBAL.style.backgroundColor,
                fontFamily: GLOBAL.fonts.bold,
                marginBottom: GLOBAL.padding / 4,
              }}
            >
              {header?.title}
            </Text>
            <Text
              style={{
                fontSize: 14,
                color: GLOBAL.style.backgroundColor,
                opacity: 0.65,
                fontFamily: GLOBAL.fonts.regular,
              }}
            >
              {header?.subtitle}
            </Text>
          </View>
        </View>
      </View>
    );
  };

  renderMatch = () => {
    // console.log("Render match");
    return (
      <Match
        data={this.state.match_card}
        index={0}
        screen={true}
        hideControls={true}
        disablePress
      />
    );
  };

  renderMain = () => {
    var {
      activeView,
      tabs,
      id,
      isLive,
      abbreviations,
      players,
      stream_data,
      displayList,
    } = this.state;

    let header = null;
    if (displayList) {
      header = this.renderTopSection();
    }

    var render = null;
    if (activeView === "watch") {
      render = <Watch listHeader={header} data={stream_data} />;
    } else if (activeView === "preview") {
      render = (
        <Preview
          listHeader={header}
          tabLabel={"Preview"}
          forceTab={this.forceTab}
          id={id}
        />
      );
    } else if (activeView === "stats") {
      render = (
        <Stats
          listHeader={header}
          tabLabel={"Stats"}
          id={id}
          abbreviations={abbreviations}
          isLive={isLive}
        />
      );
    } else if (activeView === "recap") {
      render = (
        <Recap
          listHeader={header}
          tabLabel={"Recap"}
          id={id}
          players={players}
          isLive={isLive}
        />
      );
    } else if (activeView === "chat") {
      render = null;
    } else if (activeView === "preview") {
      render = (
        <Preview
          listHeader={header}
          tabLabel={"Preview"}
          forceTab={this.forceTab}
          id={id}
        />
      );
    } else if (activeView === "odds") {
      render = <Odds listHeader={header} tabLabel={"Odds"} id={id} />;
    } else if (activeView === "h2h&bios") {
      render = <H2H listHeader={header} tabLabel={"H2H & Bios"} id={id} />;
    } else if (activeView === "form") {
      render = (
        <Form
          listHeader={header}
          tabLabel={"Form"}
          players={players}
          match_id={this.props?.id || this.props?.route?.params?.id}
        />
      );
    }

    if (header) {
      return (
        <View style={[{ width: "100%", flex: 1 }, MainStyles.flexStartCenter]}>
          {render}
        </View>
      );
    }

    return (
      <View style={[{ width: "100%" }, MainStyles.flexStartCenter]}>
        {
          // this.renderHeader()
        }
        <View
          style={{
            maxWidth: GLOBAL.maxWidth,
            width: "100%",
            borderRadius: 0,
            backgroundColor: GLOBAL.isMobile ? null : GLOBAL.style.cardColor,
            borderWidth: 0,
            borderColor: GLOBAL.style.borderColor,
          }}
        >
          <View
            style={[
              { width: "100%" },
              MainStyles.flexRow,
              MainStyles.flexCenterStart,
            ]}
          >
            <View style={{ flex: 1 }}>
              {this.renderTopSection()}
              {render}
            </View>
          </View>
        </View>
      </View>
    );
  };

  renderTopSection = () => {
    var { activeView, tabs, id, isLive, abbreviations, players, stream_data } =
      this.state;
    return (
      <>
        <View
          style={{
            width: "100%",
            borderBottomColor: GLOBAL.style.content?.borderColor,
            borderBottomWidth: 1,
          }}
        >
          {this.renderMatch()}
        </View>
        <View
          style={[
            {
              width: "100%",
              borderBottomWidth: 1,
              borderBottomColor: GLOBAL.style.content?.borderColor,
            },
            MainStyles.flexCenter,
          ]}
        >
          <Tabs tabs={tabs} onChange={this.changeTab} active_tab={activeView} />
        </View>
      </>
    );
  };

  renderHighlights = () => {
    var { highlights, wsc_story } = this.state;
    if (!highlights) {
      return null;
    }

    const img = highlights.thumbnail;
    const id = highlights.url;
    var id_youtube = id ? id.split("?v=")[1] : "";

    return (
      <View
        style={{
          width: "100%",
          paddingHorizontal: 0,
          borderRadius: GLOBAL.borderRadius,
          overflow: "hidden",
          backgroundColor: GLOBAL.style.content.card,
          marginBottom: 12,
        }}
      >
        <Text
          style={{
            ...GLOBAL.typography.cardTitle,
            paddingHorizontal: 16,
            paddingVertical: 12,
          }}
        >
          Official highlights
        </Text>
        <Pressable
          onPress={this.openVideo}
          style={{
            width: "100%",
            aspectRatio: 16 / 9,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Image
            style={{
              width: "100%",
              aspectRatio: 16 / 9,
              borderRadius: 0,
              marginTop: 0,
              resizeMode: "cover",
              // opacity:0.5,
            }}
            source={{ uri: img }}
          />

          <View
            style={{
              position: "absolute",
              aspectRatio: 1,
              width: "15%",
              backgroundColor: "rgba(0,0,0,0.4)",
              borderRadius: 100,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Image
              style={{
                width: "50%",
                aspectRatio: 1,
                resizeMode: "cover",
                tintColor: "white",
              }}
              source={require("../assets/icons/play.png")}
            />
          </View>
        </Pressable>
      </View>
    );
  };

  renderStory = () => {
    var { wsc_story, highlights } = this.state;
    if (!wsc_story) {
      return null;
    }

    const img = wsc_story.thumbnail?.src;
    const id = wsc_story.sdkId;

    return (
      <Pressable
        onPress={this.playStory}
        style={{
          width: "100%",
          paddingHorizontal: 0,
          borderRadius: GLOBAL.borderRadius,
          overflow: "hidden",
          // backgroundColor: GLOBAL.style.content.card,
          marginBottom: 12,
        }}
      >
        <View
          style={{
            height: "100%",
            width: "100%",
            position: "absolute",
            backgroundColor: GLOBAL.style.cta.backgroundColor,
            opacity: 0.1,
          }}
        />

        <View
          style={{
            width: "100%",
            // aspectRatio: wsc_story?.thumbnail?.aspectRatio,
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row",
            // paddingBottom: 12,
            // paddingHorizontal:16,
            // paddingVertical:12,
            // paddingTop:12,
            // borderTopWidth:1,
            // borderTopColor:GLOBAL.style.content.borderColor,
          }}
        >
          <View
            style={{
              flex: 1,
              justifyContent: "center",
              alignItems: "flex-start",
              paddingLeft:16,
              paddingRight: 16,
            }}
          >
            <Text
              style={{
                ...GLOBAL.typography.cardTitle,
              }}
            >
              Match story
            </Text>
            <Text
              style={{
                flex: 1,
                textAlign: "left",
                color: GLOBAL.style.color,
                fontSize: 12,
                fontFamily: GLOBAL.fonts.regular,
                lineHeight: 17,
                marginTop:6,
                opacity:0.75,
              }}
            >
              Watch short-form highlights of this match
            </Text>
          </View>
          <View
            style={{
              height: 100,
              aspectRatio: wsc_story?.thumbnail?.aspectRatio,
              // borderRadius: 4,
              overflow: "hidden",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Image
              style={{
                height: "100%",
                width: "100%",
                marginTop: 0,
                resizeMode: "cover",
                // opacity:0.5,
              }}
              source={{ uri: img }}
            />

            <View
              style={{
                position: "absolute",
                aspectRatio: 1,
                width: "35%",
                backgroundColor: "rgba(0,0,0,0.4)",
                borderRadius: 100,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Image
                style={{
                  width: "50%",
                  aspectRatio: 1,
                  resizeMode: "cover",
                  tintColor: "white",
                }}
                source={require("../assets/icons/play.png")}
              />
            </View>
          </View>
        </View>
      </Pressable>
    );

    return (
      <Pressable
        onPress={this.playStory}
        style={{
          width: "100%",
          paddingHorizontal: 0,
          borderRadius: GLOBAL.borderRadius,
          overflow: "hidden",
          backgroundColor: GLOBAL.style.content.card,
          marginBottom: 12,
        }}
      >
        <Text
          style={{
            ...GLOBAL.typography.cardTitle,
            paddingHorizontal: 16,
            paddingVertical: 12,
          }}
        >
          Key moments
        </Text>
        <View
          style={{
            width: "100%",
            aspectRatio: wsc_story?.thumbnail?.aspectRatio,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Image
            style={{
              width: "100%",
              aspectRatio: wsc_story?.thumbnail?.aspectRatio,
              borderRadius: 0,
              marginTop: 0,
              resizeMode: "cover",
              // opacity:0.5,
            }}
            source={{ uri: img }}
          />

          <View
            style={{
              position: "absolute",
              aspectRatio: 1,
              width: "15%",
              backgroundColor: "rgba(0,0,0,0.4)",
              borderRadius: 100,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Image
              style={{
                width: "50%",
                aspectRatio: 1,
                resizeMode: "cover",
                tintColor: "white",
              }}
              source={require("../assets/icons/play.png")}
            />
          </View>
        </View>
      </Pressable>
    );
  };

  renderNewsArticle = (obj, i) => {
    return (
      <Hoverable>
        {({ hovered }) => (
          <Pressable
            onPress={() => Linking.openURL(obj.url)}
            style={{
              width: "100%",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              paddingVertical: 12,
              borderTopWidth: 1,
              borderTopColor: GLOBAL.style.content.borderColor,
              paddingHorizontal: 16,
              backgroundColor: hovered ? GLOBAL.style.dropdown : "transparent",
            }}
          >
            <View
              style={{ flex: 1, paddingRight: 12, alignItems: "flex-start" }}
            >
              <Text
                style={{
                  flex: 1,
                  opacity: 0.87,
                  fontFamily: GLOBAL.fonts.regular,
                  fontSize: 12,
                  lineHeight: 17,
                  color: GLOBAL.style.color,
                  textAlign: "left",
                }}
              >
                {obj.title}
              </Text>
              <Text
                style={{
                  flex: 1,
                  opacity: 0.5,
                  fontFamily: GLOBAL.fonts.regular,
                  fontSize: 11,
                  color: GLOBAL.style.color,
                  textAlign: "left",
                  marginTop: 6,
                }}
              >
                {obj.caption}
              </Text>
            </View>
            <Image
              style={{
                height: 12,
                opacity: 0.5,
                aspectRatio: 1,
                resizeMode: "contain",
                tintColor: GLOBAL.style.color,
              }}
              source={require("../assets/icons/chevron-forward.png")}
            />
          </Pressable>
        )}
      </Hoverable>
    );
  };

  renderNews = () => {
    const { news } = this.state;
    if (!news || (!news?.all?.length && !news?.previews?.length)) return null;

    let renderAll, renderPreviews;

    if (news.all.length) {
      renderAll = (
        <View
          style={{
            width: "100%",
            paddingHorizontal: 0,
            borderRadius: GLOBAL.borderRadius,
            overflow: "hidden",
            backgroundColor: GLOBAL.style.content.card,
            marginBottom: 12,
          }}
        >
          <Text
            style={{
              ...GLOBAL.typography.cardTitle,
              paddingHorizontal: 16,
              paddingVertical: 12,
            }}
          >
            Related news
          </Text>
          {news.all.slice(0, 5).map((obj, i) => this.renderNewsArticle(obj, i))}
        </View>
      );
    }

    if (news.previews.length) {
      renderPreviews = (
        <View
          style={{
            width: "100%",
            paddingHorizontal: 0,
            borderRadius: GLOBAL.borderRadius,
            overflow: "hidden",
            backgroundColor: GLOBAL.style.content.card,
            marginBottom: 12,
          }}
        >
          <Text
            style={{
              ...GLOBAL.typography.cardTitle,
              paddingHorizontal: 16,
              paddingVertical: 12,
            }}
          >
            Previews
          </Text>
          <Image
            style={{ width: "100%", aspectRatio: 16 / 9, resizeMode: "cover" }}
            source={{ uri: news.previews.find((obj) => obj.image)?.image }}
          />
          {news.previews
            .slice(0, 5)
            .map((obj, i) => this.renderNewsArticle(obj, i))}
        </View>
      );
    }

    return (
      <View>
        {renderPreviews}
        {renderAll}
      </View>
    );
  };

  renderLinks = () => {
    const { related_links, highlights } = this.state;
    if (!related_links?.length) return null;

    return (
      <View
        style={{
          width: "100%",
          paddingHorizontal: 0,
          borderRadius: GLOBAL.borderRadius,
          overflow: "hidden",
          backgroundColor: GLOBAL.style.content.card,
          marginTop: highlights ? 12 : 0,
        }}
      >
        <Text
          style={{
            ...GLOBAL.typography.cardTitle,
            paddingHorizontal: 16,
            paddingVertical: 12,
            // paddingTop:12,
          }}
        >
          Related links
        </Text>
        {related_links.map((section) => (
          <View
            style={{
              width: "100%",
              // borderTopWidth: 1,
              // borderTopColor: GLOBAL.style.content.borderColor,
            }}
          >
            <View
              style={{
                width: "100%",
                paddingVertical: 6,
                backgroundColor: GLOBAL.style.section_title.backgroundColor,
              }}
            >
              <Text
                style={{
                  color: GLOBAL.style.color,
                  fontSize: 12,
                  fontFamily: GLOBAL.fonts.bold,
                  width: "100%",
                  textAlign: "left",
                  paddingHorizontal: 16,
                }}
              >
                {section.title}
              </Text>
            </View>
            {section.data.map((obj, i) => (
              <Hoverable>
                {({ hovered }) => (
                  <Pressable
                    onPress={() => Linking.openURL(obj.url)}
                    style={{
                      width: "100%",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      paddingVertical: 12,
                      borderTopWidth: i ? 1 : 0,
                      borderTopColor: GLOBAL.style.content.borderColor,
                      paddingHorizontal: 16,
                      backgroundColor: hovered
                        ? GLOBAL.style.dropdown
                        : "transparent",
                    }}
                  >
                    <Text
                      style={{
                        flex: 1,
                        opacity: 0.87,
                        paddingRight: 12,
                        fontFamily: GLOBAL.fonts.regular,
                        fontSize: 12,
                        color: GLOBAL.style.color,
                        textAlign: "left",
                      }}
                    >
                      {obj.label}
                    </Text>
                    <Image
                      style={{
                        height: 12,
                        opacity: 0.5,
                        aspectRatio: 1,
                        resizeMode: "contain",
                        tintColor: GLOBAL.style.color,
                      }}
                      source={require("../assets/icons/chevron-forward.png")}
                    />
                  </Pressable>
                )}
              </Hoverable>
            ))}
          </View>
        ))}
      </View>
    );
  };

  openPlayer = (player) => {
    this.props.navigation.navigate("Player", { id: player.id.split(":")[2] });
  };

  renderPlayers = () => {
    const { players } = this.state;
    if (!players?.length) return null;

    return (
      <View
        style={{
          width: "100%",
          paddingHorizontal: 0,
          borderRadius: GLOBAL.borderRadius,
          overflow: "hidden",
          backgroundColor: GLOBAL.style.content.card,
          marginBottom: 12,
        }}
      >
        <Text
          style={{
            ...GLOBAL.typography.cardTitle,
            paddingHorizontal: 16,
            paddingVertical: 12,
            // paddingTop:12,
          }}
        >
          Players
        </Text>
        {players.map((player, i) => (
          <Hoverable>
            {({ hovered }) => (
              <Pressable
                onPress={() => this.openPlayer(player)}
                style={{
                  width: "100%",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  paddingVertical: 12,
                  borderTopWidth: i ? 1 : 1,
                  borderTopColor: GLOBAL.style.content.borderColor,
                  paddingHorizontal: 16,
                  backgroundColor: hovered
                    ? GLOBAL.style.dropdown
                    : "transparent",
                }}
              >
                <Text
                  style={{
                    flex: 1,
                    opacity: 0.87,
                    paddingRight: 12,
                    fontFamily: GLOBAL.fonts.regular,
                    fontSize: 12,
                    color: GLOBAL.style.color,
                    textAlign: "left",
                  }}
                >
                  {player.name}
                </Text>
                <Image
                  style={{
                    height: 12,
                    opacity: 0.5,
                    aspectRatio: 1,
                    resizeMode: "contain",
                    tintColor: GLOBAL.style.color,
                  }}
                  source={require("../assets/icons/chevron-forward.png")}
                />
              </Pressable>
            )}
          </Hoverable>
        ))}
      </View>
    );
  };

  render = () => {
    try {
      return this.renderContent();
    } catch (e) {
      return null;
    }
  };
}
